import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import * as CryptoJS from "crypto-js";
import { Observable, Subject } from "rxjs";

@Injectable()
export class UserService {
  getEventRoute = "/api/user/";
  tokenFromUI: string = "1e2f3g4c5h7a8x9q";
  tokenFromIV: any;
  private sharedData: Subject<any> = new Subject<any>();
  sharedData$: Observable<any> = this.sharedData.asObservable();

  constructor(private dataService: DataService) {}

  getLookUp(refresh: boolean) {
    return this.dataService.getData("/api/user/lookup", refresh);
  }
  getAppVersion(apptype: any, refresh: boolean) {
    return this.dataService.getData("/api/common/version/" + apptype, refresh);
  }
  logout(refresh: boolean) {
    return this.dataService.getData("/api/user/logout", refresh);
  }
  getUserLook(subdivision, refresh: boolean) {
    return this.dataService.getData(
      "/api/user/getSubDivisionByUserList/" + subdivision,
      refresh
    );
  }
  getProfileName(refresh: boolean) {
    return this.dataService.getData("/dashboardroute/pageRole/1", refresh);
  }

  // get(subdivisionId: number, refresh: boolean) {
  //     return this.dataService.getData('/api/user/bysubdivision/' + subdivisionId, refresh);
  // }
  get(data: any, refresh: boolean) {
    return this.dataService.getData(
      "/api/user/" + data.region + "/" + data.division + "/" + data.subdivision,
      refresh
    );
  }
  getById(id: number, refresh: boolean) {
    return this.dataService.getData("/api/user/" + id, refresh);
  }

  save(result: any) {
    // result.confirmPassword = btoa(result.confirmPassword);
    this.tokenFromIV =
      (Math.random() + " ").substring(2, 10) +
      (Math.random() + " ").substring(2, 10);
    if (result.password) {
      let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
      let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromIV);
      let encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(result.password),
        _key,
        {
          keySize: 16,
          iv: _iv,
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      var encryptKeyIv = this.tokenFromIV + encrypted.toString();
    }
    // result.password = btoa(result.password);
    result.password = btoa(encryptKeyIv);
    return this.dataService.post("/api/user", result).map((response) => {
      this.dataService.clearRouteCache(this.getEventRoute);
      return response;
    });
  }

  delete(id: number, status: number) {
    return this.dataService
      .post("/api/user/update/" + id + "/" + status, null)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }

  forgotpasswordUser(user: any) {
    return this.dataService
      .post("/api/user/forgotpassword", user)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }

  changepasswordUser(result) {
    return this.dataService
      .post("/passwordlistroute/changePassword", result)
      .map((response) => {
        return response;
      });
  }

  newpaswordUser(user: any) {
    return this.dataService
      .post("/api/user/newpasword", user)
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }
  getRoll(refresh: boolean) {
    return this.dataService.getData("/api/user/role", refresh);
  }
  getUserImg(userid: any, refresh: any) {
    return this.dataService.getData("/api/user/" + userid, refresh);
  }
  getMenu(refresh: boolean) {
    return this.dataService.getData("/api/user/menu", refresh);
  }
  getvirtualCardDetails(result) {
    return this.dataService
      .post("/virtualroute/AllocateCreateVirtualCard", result)
      .map((response) => {
        return response;
      });
  }
  getProfileNumber(clientid: number, profile_type: number, refresh: boolean) {
    return this.dataService.getData(
      "/getprofilenumberbyclientid/" + clientid + "/" + profile_type,
      refresh
    );
  }
  setpopupData(data: any) {
    this.sharedData.next(data);
  }
  getBannerImg(clientid: number, profile_type: number, refresh) {
    return this.dataService
      .post(
        "/profileroute/getparentid/" + clientid + "/" + profile_type,
        refresh
      )
      .map((response) => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
      });
  }
  updateBanner(request) {
    return this.dataService
      .post("/profileroute/update_banner", request)
      .map((response) => {
        return response;
      });
  }
 
}
